import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    temperature: Yup.number().nullable(),
    thermodiagramConform: Yup.boolean().nullable(),
    sealList: Yup.array().of(
      Yup.object().shape({
        id: Yup.string().nullable(),
        code: Yup.string().nullable(),
        integral: Yup.boolean()
      })
    ),
    documentList: Yup.array().of(
      Yup.object().shape({
        depositId: Yup.string().nullable(),
        depositName: Yup.string(),
        hasNotice: Yup.boolean().nullable(),
        hasTransportNote: Yup.boolean().nullable()
      })
    ),
    driverConform: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.string().oneOf(['DRIVER_ASSISTED', 'DRIVER_EQUIPPED']),
          label: Yup.string().oneOf(['Ajutor la descărcare', 'Corect echipat'])
        })
      )
      .nullable(),
    driverName: Yup.string().required('Numele soferului este obligatoriu.')
  })

export const getInitialValues = () => ({
  temperature: 'test',
  thermodiagramConform: true,
  sealList: [{ id: '', code: '', integral: true }],
  documentList: [{ depositId: null, depositName: '', hasNotice: true, hasTransportNote: true }],
  driverConform: [],
  driverName: ''
})

export const driverConformOptions = [
  { value: 'DRIVER_ASSISTED', label: 'Ajutor la descărcare' },
  { value: 'DRIVER_EQUIPPED', label: 'Corect echipat' }
]
